import React, { FunctionComponent, useEffect } from "react";
import { FieldValues, useFieldArray, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { updateLoading } from "../../redux/slice/appSlice";
import { createDiseaseDetail } from "../../services";
import { CreateDiseaseInput } from "../../types/api";
import { DiseaseForm } from "./form";

export const DiseaseCreate: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { register, handleSubmit, control } = useForm();
  const { fields, append, swap, remove } = useFieldArray({
    name: "image_url",
    control
  });

  useEffect(() => {
    dispatch(updateLoading(false));
  }, [dispatch]);
  const onSubmit = async (data: FieldValues) => {
    const diseaseData: CreateDiseaseInput = {
      name: data.name,
      description: data.description,
      detection: data.detection,
      management: data.management,
      notes: data.notes,
      image_url: data.image_url
    };
    createDiseaseDetail({
      dispatch,
      diseaseData,
      navigate
    });
  };
  return (
    <DiseaseForm
      onSubmit={onSubmit}
      register={register}
      handleSubmit={handleSubmit}
      image_field={fields}
      image_append={append}
      image_swap={swap}
      image_remove={remove}
    />
  );
};
